import { ListType, withListsReact, withLists as withPrezlyLists } from "@prezly/slate-lists";
import { Element } from "slate";
export const withLists = (editor) => withListsReact(withPrezlyLists({
    isConvertibleToListTextNode(node) {
        return (Element.isElementType(node, "paragraph") ||
            Element.isElementType(node, "headingOne") ||
            Element.isElementType(node, "headingTwo") ||
            Element.isElementType(node, "headingThree") ||
            Element.isElementType(node, "headingFour") ||
            Element.isElementType(node, "headingFive") ||
            Element.isElementType(node, "headingSix") ||
            Element.isElementType(node, "quote"));
    },
    isDefaultTextNode(node) {
        return Element.isElementType(node, "paragraph");
    },
    isListNode(node, type) {
        if (type) {
            return Element.isElementType(node, type);
        }
        return Element.isElementType(node, "orderedList") || Element.isElementType(node, "unorderedList");
    },
    isListItemNode(node) {
        return Element.isElementType(node, "list-item");
    },
    isListItemTextNode(node) {
        return Element.isElementType(node, "list-item-text");
    },
    createDefaultTextNode(props = {}) {
        return { children: [{ text: "" }], ...props, type: "paragraph" };
    },
    createListNode(type = ListType.UNORDERED, props = {}) {
        const nodeType = type === ListType.ORDERED ? "orderedList" : "unorderedList";
        return { children: [{ text: "" }], ...props, type: nodeType };
    },
    createListItemNode(props = {}) {
        return { children: [{ text: "" }], ...props, type: "list-item" };
    },
    createListItemTextNode(props = {}) {
        return { children: [{ text: "" }], ...props, type: "list-item-text" };
    }
})(editor));
